import { Avatar, Flex, Typography } from 'antd'
import React from 'react'
import { styled } from 'styled-components'
import { useUserContext } from '~/core/context'

const Wrapper = styled.div`
  width: 340px;
  background: white;
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`

const NotificationText = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const IphoneNotification: React.FC = () => {
  const { session } = useUserContext()

  const name = session.user.name ?? ''

  return (
    <Wrapper className="p-2">
      <Flex gap={8}>
        <Flex align="center">
          <Avatar
            src="https://marblism-ai-agents-public.s3.us-west-2.amazonaws.com/assets/agent-ea.webp"
            size={30}
            shape="square"
          />
        </Flex>

        <NotificationText>
          <Flex justify="space-between" align="center">
            <Typography.Text strong style={{ fontSize: '12px' }}>
              Eva
            </Typography.Text>
            <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
              now
            </Typography.Text>
          </Flex>
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            Hi {name}! 👋 I'm Eva, your new assistant. Looking forward to making
            your day-to-day a bit smoother!
          </Typography.Text>
        </NotificationText>
      </Flex>
    </Wrapper>
  )
}
